export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const GENDER_OPTIONS = [
  { value: '', label: 'Select gender (optional)' },
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
];

export const splitUsername = (username = '') => {
  const trimmed = username.trim();
  const spaceIndex = trimmed.indexOf(' ');

  if (spaceIndex === -1) {
    return { firstName: trimmed, lastName: '' };
  }

  return {
    firstName: trimmed.slice(0, spaceIndex).trim(),
    lastName: trimmed.slice(spaceIndex + 1).trim(),
  };
};

export const buildUsername = (firstName, lastName) =>
  `${firstName || ''} ${lastName || ''}`.trim().replace(/\s+/g, ' ');

export const getEmptyUserForm = () => ({
  firstName: '',
  lastName: '',
  username: '',
  email: '',
  password: '',
  confirmPassword: '',
  designation: '',
  gender: '',
  role: '',
  department: '',
  isActive: true,
});

export const mapUserToForm = (user) => {
  const split = splitUsername(user.username || '');
  const firstName = user.firstName || split.firstName;
  const lastName = user.lastName || split.lastName;

  return {
    firstName,
    lastName,
    username: user.username || buildUsername(firstName, lastName),
    email: user.email || '',
    password: '',
    confirmPassword: '',
    designation: user.designation || '',
    gender: user.gender || '',
    role: user.role?._id || user.role || '',
    department: user.department?._id || user.department || '',
    isActive: user.isActive !== false,
  };
};

export const validateUserForm = (formData, { isEdit = false } = {}) => {
  const errors = {};
  const firstName = formData.firstName?.trim();
  const lastName = formData.lastName?.trim();
  const email = formData.email?.trim();
  const password = formData.password;
  const confirmPassword = formData.confirmPassword;

  if (!firstName) errors.firstName = 'First name is required.';
  if (!lastName) errors.lastName = 'Last name is required.';
  if (!email) errors.email = 'Email is required.';
  else if (!EMAIL_REGEX.test(email)) errors.email = 'Enter a valid email address.';

  if (!isEdit && !password) errors.password = 'Password is required.';
  if (!isEdit && !confirmPassword) errors.confirmPassword = 'Confirm password is required.';

  if (password && password.length < 6) {
    errors.password = 'Password must be at least 6 characters.';
  }

  if (password || confirmPassword) {
    if (password !== confirmPassword) {
      errors.confirmPassword = 'Passwords do not match.';
    }
  }

  if (!formData.role) errors.role = 'Role is required.';
  if (!formData.department) errors.department = 'Department is required.';

  return errors;
};
